<!-- notas -->

<div class="loader" [hidden]="preview.status_code==1">
    <div class="dimmed_outset">
        <div class="dimmed preview-viewer">
             <div class="dimmed_box doble_h"></div>
        </div>
    </div>
    <!--   <core-helpers-box-loading [hidden]="preview.status_code==1"></core-helpers-box-loading> -->
</div>
<core-previews-carousel
    *ngIf="preview.total_pages > 1"
    [preview]="preview"
    (onClickPage)="selectPage($event)"
    [selectedPage]="page"
>
</core-previews-carousel>

<div class="note-box-main">
<div class="note-list-main" [hidden]="list.length == 0">
    <core-helpers-lists-ordered
        *ngIf="preview.status_code == 1"
        [elements]="list"
        [title]="'List notes'"
        (select)="onListSelect($event)">
    </core-helpers-lists-ordered>
</div>

<!-- <div *ngIf="preview.status_code == 1">
    <core-notes-viewer
        *ngFor="let p of pages"
        [hidden]="page != p"
        [file]="file"
        [page]="p"
        [notes]="notes"
        [selected]="noteSelected"
        (onClick)="onClick.emit($event);"
    ></core-notes-viewer>
</div> -->
<core-notes-viewer
    *ngIf="preview.status_code == 1"
    [file]="file"
    [page]="page"
    [notes]="notes"
    [selected]="noteSelected"
    [canCreate]="canCreate"
    (onClick)="onClick.emit($event);"
>
</core-notes-viewer>
</div>
